import React from "react";
import {
  KelasLiveCTABlockButton,
  KelasLiveCTABlockButtonContainer,
  KelasLiveCTABlockContainer,
  KelasLiveCTABlockTitle,
  KelasLiveCTABlockImageWrapper,
  KelasLiveCTABlockImage
} from "./kelas-live-cta-block.styles";
import { Spacer } from "styles/common/spacer";
import { Container } from "styles/common/container";
import Link from "next/link";
import { useAuth } from "stores/auth/auth-context";
import { useTrialActivationModal } from "../trial-activation-modal/use-trial-activation";
import { TrialActivationModal } from "../trial-activation-modal/trial-activation-modal";

const KelasLiveCTABlock: React.FC = () => {
  const {
    user: { userData }
  } = useAuth();
  const { showTrialActivation, setShowTrialActivation } =
    useTrialActivationModal(userData?.primary_user?.access_token);
  return (
    <>
      <KelasLiveCTABlockContainer>
        <Container>
          <KelasLiveCTABlockTitle>
            Siap melangkah lebih dekat menuju cita-citamu?
          </KelasLiveCTABlockTitle>
          <Spacer token={[16, 32, 16]} />
          <KelasLiveCTABlockButtonContainer>
            <Link href="/paket" passHref>
              <KelasLiveCTABlockButton>
                Cek paket belajar
              </KelasLiveCTABlockButton>
            </Link>
            <KelasLiveCTABlockButton
              isOutlined
              onClick={() => setShowTrialActivation.on()}>
              Coba gratis dulu
            </KelasLiveCTABlockButton>
          </KelasLiveCTABlockButtonContainer>
        </Container>
        <Spacer token={[30, 30, 16]} />
        <KelasLiveCTABlockImageWrapper>
          <KelasLiveCTABlockImage
            src="/assets/kelas-live/nara-practice.svg"
            alt="Nara and Coco practicing"
          />
        </KelasLiveCTABlockImageWrapper>
      </KelasLiveCTABlockContainer>
      {showTrialActivation && (
        <TrialActivationModal onClose={() => setShowTrialActivation.off()} />
      )}
    </>
  );
};

export { KelasLiveCTABlock };
